import { render, staticRenderFns } from "./AffiliatesBalance.vue?vue&type=template&id=24a3bb30&scoped=true"
import script from "./AffiliatesBalance.vue?vue&type=script&lang=js"
export * from "./AffiliatesBalance.vue?vue&type=script&lang=js"
import style0 from "./AffiliatesBalance.vue?vue&type=style&index=0&id=24a3bb30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a3bb30",
  null
  
)

export default component.exports